import { PARTNERS_TABS } from "@/Routes/partnerSidebar.utility";
import { apiRequest } from "@repo/api-services/Axios";

import URLS from "@repo/api-services/URLS";
import { handleErrorToast } from "@repo/ui/libs";
import { stringUtility } from "@repo/utilities/string.utility.ts";

export const getRedirectPathFromAuth = async () => {
  const authUserResponse = await apiRequest.get(URLS.AUTH_USER);

  const permissionsMap = authUserResponse?.data?.permissions;

  // For admin who have all the permissions, redirect to the first tab
  if (Array.isArray(permissionsMap) && permissionsMap.includes("*")) {
    return PARTNERS_TABS[0].subTabs
      ? PARTNERS_TABS[0].subTabs[0].path
      : PARTNERS_TABS[0].path;
  }

  const accessibleTabCodes = new Set<string>(
    Object.keys(permissionsMap).map((permissionKey) =>
      stringUtility.replaceCharAll(permissionKey, "_", "-")
    )
  );

  const firstAccessibleTab = PARTNERS_TABS.flatMap(
    (tab) => tab.subTabs ?? [tab]
  ).find((tab) => accessibleTabCodes.has(tab.code));

  if (!firstAccessibleTab) {
    localStorage.clear();
    handleErrorToast({
      message:
        "You do not have access to any page. Please contact administrator.",
    });
    return "/login";
  }

  return firstAccessibleTab.path;
};
